import React from 'react';
import { motion } from 'framer-motion';
import { AwardIcon, PenLineIcon, UsersIcon, HandshakeIcon, CompassIcon, SparklesIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { BENEFITS } from './salesData';
const ICONS = [AwardIcon, PenLineIcon, UsersIcon, HandshakeIcon, CompassIcon, SparklesIcon];
export function BenefitsSection() {
  return <section id="beneficios" className="bg-sand py-12 sm:py-16" data-id="element-44" data-mp="38sacbcvpuvi4">
      <div className="mx-auto max-w-5xl px-5" data-id="element-45" data-mp="38qpkvw4p7soh">
        <div className="text-center" data-id="element-46" data-mp="3drn0c0ybq8ma">
          <SectionTag data-id="element-47" data-mp="3dsoliy920bhq">Beneficios</SectionTag>
          <h2 className="mt-4 font-display text-[1.6rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.3rem]" data-id="element-48" data-mp="2zrlwqdqocn34">
            Dejá de improvisar.
            <span className="mt-1 block text-gold-deep" data-id="element-49" data-mp="34qp4w71yb9fb">Empezá a construir.</span>
          </h2>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-50" data-mp="xxwejotw8t0c">
          {BENEFITS.map((benefit, i) => {
          const Icon = ICONS[i % ICONS.length];
          return <motion.article key={benefit.title} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.35,
            delay: i * 0.05
          }} className="h-full rounded-xl border border-stone bg-ivory p-5" data-id="element-51" data-mp="2bdcq7g9739we" data-mpi={i}>
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold-soft" data-id="element-52" data-mp="1sh35wb7p9n3y">
                  <Icon className="h-5 w-5 text-gold-deep" aria-hidden data-id="element-53" data-mp="1ogarz4nvuu1c" />
                </span>
                <h3 className="mt-3.5 font-display text-[0.9rem] font-bold uppercase leading-snug tracking-wide text-charcoal" data-id="element-54" data-mp="22fakineint2s">
                  {benefit.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-charcoal/70" data-id="element-55" data-mp="3dslcf5x3bfw1">
                  {benefit.desc}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}